import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  ShoppingDataInitialLoad,
  ShoppingFilterData,
  ShoppingFilterItem
} from '@models/shopping.model';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { FilterStateService } from '@services/filter-state/filter-state.service';
import { TranslationService } from '@services/translation/translation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ts-filters',
  templateUrl: './filters.component.html',
  imports: [CommonModule, NgbAccordionModule]
})
export class FiltersComponent implements OnInit, OnDestroy {
  @Input() filters: ShoppingFilterData[] = [];
  @Input() is_mobile: boolean = false;
  accordion_item_classes: string = '';
  applied_filter: ShoppingFilterItem[] = [];

  private subscriptions: Subscription = new Subscription();

  constructor(
    private filter_state_service: FilterStateService,
    public translation_svc: TranslationService
  ) {}

  ngOnInit(): void {
    this.accordion_item_classes = this.is_mobile
      ? 'accordion-item mb-2'
      : 'accordion-item mb-2 filters-accordion__item';

    this.subscriptions.add(
      this.filter_state_service.filter_changes.subscribe(() => {
        this.applied_filter = this.filter_state_service.filtersParam.filters;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  handleFilterSelection(
    filter_config_id: number,
    item: ShoppingFilterItem['item'],
    event: any
  ): void {
    if (event.target.checked) {
      this.applied_filter.push({ id: filter_config_id, value: item });
    } else {
      this.applied_filter = this.applied_filter.filter((option: ShoppingFilterItem) => {
        if (item === 'Unknown') return option.id != filter_config_id;
        else return option.value !== item;
      });
    }
    this.updateFilterParams();
  }

  private updateFilterParams(): void {
    const filters_param: ShoppingDataInitialLoad = this.filter_state_service.filtersParam;
    filters_param.filters = this.applied_filter;

    this.filter_state_service.filtersParam = filters_param;
  }
}
